<template slot-scope="scope">
  <!-- 车险活动购买信息弹窗 -->
      <dialogModel
        title="提示"
        :visible.sync="dialogInstruction"
        @handleClose="handleCloseInstruction"
        @handleOk="handleInstruction"
      >
        <div>
          <p class="Hint-p" v-if="Instruction == 0 && willConsumeCard">
            剩余精英卡{{ EliteCard }}张，此操作将消耗一张精英卡，是否继续操作？
          </p>
          <p class="Hint-p" v-else-if="Instruction == 0 && !willConsumeCard">
            剩余精英卡{{ EliteCard }}张，确认申请查看对方联系方式？
          </p>
          <p class="Hint-p" v-else>
            剩余人才信用卡{{ Credit }}张，此操作将消耗一张人才信用卡，是否继续操作？
          </p>
        </div>
      </dialogModel>
</template>

<script>
export default {
  props: {
    dialogInstruction: {},

    EliteCard: {}, //精英卡剩余数量
    Credit: {}, //人才信用卡剩余数量
    Instruction: {}, //0精英提示  1信用提示
    /** 是否提示消耗一张卡；false 时仅展示剩余精英卡并确认申请（如无需扣卡场景） */
    willConsumeCard: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    // 关闭弹窗
    handleCloseInstruction() {
      this.$emit("handleCloseInstruction");
    },
    handleInstruction() {
      this.$emit("handleInstruction");
    },
  },
};
</script>

<style scoped lang="less">
.box-instruction {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  .Instructions {
    font-size: 12px;
    color: #999999;
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.Hint-p {
  height: 100%;
  margin: auto;
  text-align: center;
}
</style>
